import React from 'react'
import "./css/common.css"

export default function ReportGenerationTab(props) {
        return (
                <div className="main_tab scrollbar_property">
                        REPORT GENERATION
                        <br></br>
                        {props.selected_dataset}
                </div>
        )
}
